import { createAsyncThunk } from '@reduxjs/toolkit';
import cache from '~/cache';
import { setModal } from '~/slice';

export default createAsyncThunk(
  'modals/openModal',
  async ({ modal: { modalId, ...data } = {}, trigger }, { dispatch, getState }) => {
    if (!modalId) throw new Error('`modalId` is required');

    await dispatch(setModal({ modal: { modalId, ...data }, trigger }));

    cache[modalId] ??= {};

    cache[modalId].promise ??= new Promise((resolve) => {
      cache[modalId].resolve = resolve;
    });

    const result = await cache[modalId].promise;

    return result;
  }
);
